import { ConflictError } from "./conflict-error";

// Thrown when a scanned label names a real load carrier unit that has no open leg left.
//
// A unit has at most one open transport order at a time — a partial unique index keeps that true
// — and reaching a zone with no follow-up ends its chain for good. Scanning such a label is not
// an error in the sense of a mistake: the box has arrived where it was going, and saying so is
// more useful than silently doing nothing. 409: a statement about the box, not about the request.
export class TransportOrderAlreadyClosedError extends ConflictError {
	constructor() {
		super("stock.transport_order_already_closed");
		this.name = "TransportOrderAlreadyClosedError";
	}
}
